// @flow

/**
 * Address Display to be used in Typeahead result view
 * ----------------------------------------------------
 * parent_geos: 'Boston, Massachusetts' or 'London, United Kingdom'
 * full_address: '100 Main St Boston, Massachusetts'
 * none: no address shown
 */
export type AddressDisplay = 'full_address' | 'parent_geos' | 'none';

const formatAddress = (
  addressDisplay: AddressDisplay,
  parentName: string,
  grandParentName: string,
  streetAddress: string,
): string => {
  const ancestorDisplay = [parentName, grandParentName].filter(parent => !!parent).join(', ');
  if (addressDisplay === 'full_address') {
    return streetAddress ? `${streetAddress}, ${ancestorDisplay}` : ancestorDisplay;
  } else if (addressDisplay === 'parent_geos') {
    return ancestorDisplay;
  }
  return '';
};

export default formatAddress;
